export type ChartType = "line" | "candlestick" | "histogram";

export enum TradingAssets {
  CRYPTO = "crypto",
  COMMODITIES = "commodities",
  STOCKS = "stock",
  FOREX = "forex",
}

export interface TradingPair {
  symbol: string;
  id: number;
  assetType: TradingAssets;
  icon: string;
  winPayoutRatio: number;
  winPayoutPercent: number;
  isMarketOpen: boolean;
}
export type BalanceType = "real" | "demo";

// Лимиты экспирации для выбранной пары и tier пользователя (WS t=10).
export interface ExpirationLimits {
  min_expiration_sec: number;
  max_expiration_sec: number; // 0 — без верхнего лимита
  expiration_step_sec: number;
  expiration_presets_sec: number[];
}

// Границы без пресетов — так они приходят в meta пары (WS t=8).
export type ExpirationBounds = Pick<
  ExpirationLimits,
  "min_expiration_sec" | "max_expiration_sec"
>;
